import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReferralDashboardRoutingModule } from './referral-dashboard-routing.module';
import { InstructorDashboardComponent } from './instructor-dashboard/instructor-dashboard.component';
import { SharedModule } from '@app/shared';
import { KiterDashboardComponent } from './kiter-dashboard/kiter-dashboard.component';
import { SchoolDashboardComponent } from './school-dashboard/school-dashboard.component';

@NgModule({
  declarations: [InstructorDashboardComponent, KiterDashboardComponent, SchoolDashboardComponent],
  imports: [CommonModule, ReferralDashboardRoutingModule, SharedModule],
})
export class ReferralDashboardModule {}
